import { OrderBrandId, OrderBrandResponse } from '@business/entities/order';
import { Endpoint } from '../endpoint';

export function fetchBrands() {
  return Endpoint.get<OrderBrandResponse[]>(`@gc/order-brands`);
}

export function fetchBrand(id: OrderBrandId) {
  return Endpoint.get<OrderBrandResponse>(`@gc/order-brands/stage/${id}`);
}

export function createBrand(data: Partial<OrderBrandResponse>) {
  return Endpoint.post<OrderBrandResponse>(`@gc/order-brands`, { data });
}

export function updateBrand(id: OrderBrandId, data: Partial<OrderBrandResponse>) {
  return Endpoint.patch<OrderBrandResponse>(`@gc/order-brands/${id}`, { data });
}

export function deleteBrand(id: OrderBrandId) {
  return Endpoint.delete<void>(`@gc/order-brands/${id}`);
}

export function sync() {
  return Endpoint.get<OrderBrandResponse[]>(`@gc/order-brands/sync`);
}
